<template>
  <transition-group v-if="hasErrorMessages" tag="ul" class="ErrorMessages">
    <li
      v-for="message in errorMessages"
      :key="message"
      class="ErrorMessages-item"
      v-text="message"
    ></li>
  </transition-group>
</template>

<script>
export default {
  name: 'ErrorMessages',
  props: {
    errorMessages: {
      type: Array,
      required: false,
      default: undefined,
    },
    hasErrorMessages: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../css/foundation/vars';

.ErrorMessages {
  display: block;
}

.ErrorMessages-item {
  display: block;
  padding-left: 0.5rem;
  font-size: 1.4rem;
  font-weight: bold;
  color: #ff0000;
}
</style>
